import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initErrorTracking } from './utils/errorTracking';
import { initAnalytics } from './utils/analytics';

// Initialize analytics and error tracking in production
if (process.env.NODE_ENV === 'production') {
  // Initialize GTM dataLayer
  initAnalytics();

  // Initialize error tracking
  try {
    initErrorTracking();
  } catch (err) {
    console.error('Failed to initialize error tracking:', err);
  }
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

try {
  // Puppeteer captures browser DOM, which lacks React's server hydration markers.
  ReactDOM.createRoot(root).render(app);
} catch (error) {
  console.error('Failed to render app:', error);
}
